<template>
  <div>
    <!--          option编辑-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="'オプション'"
      :visible.sync="$parent.showGoodsOptionDialogVisible"
      append-to-body
      center
      custom-class="commodityWarehouseOptionDialogContainer"
      width="1375px"
      @opened="$forceUpdate()"
    >
      <div class="optionSelectContainer">
        <div class="optionSelectHeaderContainer">
          <div class="optionSelectListContainer">
            <div class="optionArrContainer">
              <div
                v-for="(optionItem, optionIndex) in $parent.$parent.$parent
                  .optionList"
                :key="optionIndex"
                class="optionArrItemContainer"
              >
                <div
                  :class="
                    optionItem.checked == true
                      ? 'activeOptionArrItemNameContainer'
                      : 'optionArrItemNameContainer'
                  "
                  @click="updateOptionNum(optionItem)"
                >
                  <div class="optionArrItemNameLeftContainer">
                    <div>{{ optionIndex + 1 }}</div>
                    <div>{{ optionItem.name_translate }}</div>
                  </div>
                  <img
                    v-show="optionItem.checked == true"
                    :src="require('@/assets/icon/optionCheckedIcon.png')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="optionInfo.price != ''" class="optionDetailContainer">
            <el-carousel
              :arrow="carouselList.length > 1 ? 'always' : 'never'"
              :autoplay="false"
              height="252px"
              indicator-position="none"
            >
              <el-carousel-item
                v-for="(item, index) in carouselList"
                :key="index"
              >
                <img
                  v-show="item.type === 'img'"
                  :src="item.url"
                  alt=""
                  class="optionImage cursorPointer"
                  @click="imgFullscreen('.optionImage')"
                />
                <div
                  v-show="item.type != 'img'"
                  class="edy-texteditor-container video embed-container edy-positionable-container-maxwidth"
                  contenteditable="false"
                  style="
                    max-width: 100%;
                    overflow: hidden;
                    position: relative;
                    width: auto;
                  "
                  unselectable="on"
                >
                  <div
                    class="edy-padding-resizer-wrapper"
                    style="padding-bottom: 56.25%"
                  >
                    <iframe
                      id="ifrId"
                      :src="item.url"
                      allowfullscreen="allowfullscreen"
                      frameborder="0"
                      style="
                        position: absolute;
                        display: block;
                        width: 100%;
                        height: 100%;
                      "
                    ></iframe>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="optionName">{{ optionInfo.name_translate }}</div>
            <div class="optionValue" v-html="optionInfo.desc"></div>
          </div>
        </div>
        <div class="optionSelectFooterContainer">
          <div class="color999">
            Rakumartの各サービスのオプション料金を確認するためには、
            <router-link
              :to="{ path: '/option' }"
              class="colorB4272B cursorPointer"
              target="_blank"
            >
              オプション費用
            </router-link>
            をクリックしてください。
          </div>
          <div class="optionOperationBtnContainer">
            <!-- 重置 -->
            <el-button @click="resetGoodsOption">{{
              $t("message.reset")
            }}</el-button>
            <el-button type="primary" @click="saveGoodsOption">
              <!-- 保存 -->
              {{ $t("message.save") }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newOptionPrice: this.optionPrice,
      carouselList: [],
      optionInfo: {
        desc: "",
        price: "",
        unit: "",
        image: "",
      },
    };
  },
  methods: {
    //重置商品的附加服务
    resetGoodsOption() {
      this.$parent.$parent.$parent.optionList.forEach((item) => {
        item.checked = false;
      });
    },
    //保存商品的附加服务
    saveGoodsOption() {
      this.$parent.showGoodsOptionDialogVisible = false;
    },
    //防止输入框滚动增值
    stopScroll(evt) {
      evt = evt || window.event;
      if (evt.preventDefault) {
        // Firefox
        evt.preventDefault();
        evt.stopPropagation();
      } else {
        // IE
        evt.cancelBubble = true;
        evt.returnValue = false;
      }
      return false;
    },
    //输入框校验
    newChannelInputLimit(e) {
      let key = e.key;
      // 不允许输入'e'、'.'、'。'、'-'
      if (
        key === "e" ||
        key === "." ||
        key === "。" ||
        key == "-" ||
        key == "-" ||
        key == "-"
      ) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    imgFullscreen(val) {
      const el = document.querySelector(val); // 获取需要全屏的元素
      if (!document.fullscreenElement) {
        // 判断是否已经处于全屏模式
        el.requestFullscreen().catch((err) => {
          // 进入全屏模式
          console.log(`进入全屏模式失败：${err.message}`);
        });
      } else {
        document.exitFullscreen(); // 退出全屏模式
      }
    },
    //根据当前订单的番数更新option选中的数量
    updateOptionNum(item) {
      item.checked = !item.checked;
      item.num = 1;
      if (item.checked) {
        this.optionInfo = item;
      }
      this.carouselList = [];
      if (item.video != "") {
        if (item.image != "") {
          this.carouselList.push({
            url: item.image,
            type: "img",
          });
        }
        this.carouselList.push({
          url: item.video,
          type: "video",
        });
      } else {
        this.carouselList.push({
          url:
            item.image != ""
              ? item.image
              : require("@/assets/icon/optionInPreparationImage.jpg"),
          type: "img",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.optionSelectHeaderContainer {
  height: 573px;
  margin-top: 26px;
  display: flex;
  padding-bottom: 24px;

  .optionSelectListContainer {
    width: 772px;
    height: 100%;
    border-right: 1px solid #dfdfdf;

    .optionTypeName {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 18px;
    }

    .optionArrContainer {
      display: flex;
      flex-wrap: wrap;

      .optionArrItemContainer {
        width: 240px;
        margin: 0 12px 18px 0;

        .optionArrItemNameContainer,
        .activeOptionArrItemNameContainer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 12px 0 10px;
          cursor: pointer;
          background: #f8f8f8;
          height: 42px;
          margin-bottom: 6px;

          .optionArrItemNameLeftContainer {
            display: flex;
            align-items: center;

            div:first-child {
              width: 22px;
              height: 22px;
              min-width: 22px;

              background: #ffffff;
              border-radius: 50%;
              border: 1px solid #333333;
              font-size: 12px;
              color: #333333;
              text-align: center;
              line-height: 19px;
              margin-right: 5px;
            }

            div:last-child {
              font-size: 14px;
              color: #333333;
              width: 155px;
            }
          }
        }

        .activeOptionArrItemNameContainer {
          background: #faf2f2 !important;

          .optionArrItemNameLeftContainer {
            div:first-child {
              border: 1px solid #b4272b !important;
            }

            div {
              color: #b4272b !important;
            }
          }
        }

        .optionNumContainer {
          display: flex;
          align-items: center;
          padding-left: 9px;
        }

        img {
          width: 17px;
          height: 15px;
        }
      }

      .optionArrItemContainer:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .optionDetailContainer {
    margin-left: 36px;
    background: #f8f8f8;
    border-radius: 6px;
    padding: 24px 24px 0;
    width: 498px;
    overflow: scroll;

    img {
      width: 100%;
      height: 252px;
      margin-bottom: 24px;
    }

    .optionName {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 29px;
    }

    .optionLabel {
      font-size: 14px;
      color: #666666;
      margin-bottom: 30px;
    }

    .optionPrice {
      color: #b4272b;
      font-size: 18px;
      font-weight: bold;
    }

    .optionValue {
      color: #333333;
    }
  }
}

.optionSelectFooterContainer {
  width: 100%;
  border-top: 1px solid #dfdfdf;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .optionTotalPrice {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #333333;

    span {
      font-size: 24px;
      color: #b4272b;
      font-weight: bold;
    }
  }

  .optionOperationBtnContainer {
    display: flex;
    align-items: center;

    button {
      width: 120px;
      height: 34px;
      border-radius: 8px;
      padding: 0;
      font-size: 14px;
    }

    button:first-child {
      border: 1px solid #b4272b;
      color: #b4272b;
    }
  }
}
</style>
